import { useState } from 'react';
import { Button } from '@mui/material';
import * as Yup from 'yup';
import { SaveHookFormDialog } from '../../../components/save-hook-form.dialog';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';
import { BuildingFloorUnitForm } from './building-floor-unit.form';
import { useFormContext } from 'react-hook-form';
import { BuildingFloorUnitFormWithDefaultValue } from './create-building-floor-with-default-unit-name';
import { GuardedComponent } from '../../../components/guarded-component';
import { UserPermissionName } from '../../../models/user-permission-name';

interface CreateBuildingFloorButtonProps {
  projectID: number;
  buildingID?: number;
  floor: any;
  onUnitCreated: (data: any) => void;
  syncWithDux: any;
}
const validationSchema = Yup.object().shape({
  unitData: Yup.object().shape({
    unitName: Yup.string().required('Lot/Unit is required').max(9, 'Lot/Unit cannot exceed 9 characters'),
    jobsite: Yup.string().required('Jobsite is required'),
    // jobNumber: Yup.string().required('Job Number is required'),
    address: Yup.string().required('Address is required').max(31, 'Address cannot exceed 31 characters'),
  }),
});

export const CreateBuildingFloorUnitButton = ({
  projectID,
  buildingID,
  floor,
  onUnitCreated,
  syncWithDux
}: CreateBuildingFloorButtonProps) => {
  const [newBuilding, setNewBuilding] = useState<any>();
  const { setValue } = useFormContext();

  const handleDialogClose = () => {
    setNewBuilding(undefined);
  };

  const handleAddBuildingFloor = () => {
    setNewBuilding({
      projectID,
      floorName: '',
      unitData: {
        unitName: '',
        jobsite: '',
        jobNumber: '',
        // createWO: false,
        // syncWithDUX: false,
        buildingPermit: ''
      }
    });
  };

  const transformData = (data: any) => {
    return {
      unitName: data.unitName,
      jobNumber: data.jobNumber,
      jobsite: data.jobsite,
      address: data.address,
      squareFeet: !data?.squareFeet ? null : Number(data?.squareFeet),
      proctorResult: !data.proctorResult
        ? null
        : {
          proctorResultsID: data.proctorResult.proctorResultsID,
          unitID: 0,
          proctorFileName: data.proctorResult.proctorFileName,
        },
      // createWO: data.createWO,
      // syncWithDUX: data.syncWithDUX,
      buildingPermit: data.buildingPermit

      // proctorResult:
      //   data.proctorResult?.map((result: any) => ({
      //     proctorResultsID: result.proctorResultsID,
      //     unitID: 0,
      //     proctorFileName: result.proctorFileName,
      //   })) || [],
    };
  };

  const formatSubmitData = (data: any) => {
    const { floorID } = floor;

    const transformedData = transformData(data.unitData);
    return { projectID, buildingID, floorID, ...transformedData };
  };

  return (
    <>
      <GuardedComponent requiredPermissions={[UserPermissionName.ADD_UNIT]}>
        <Button
          className="btn btn-primary"
          variant="text"
          sx={{ p: 0, m: 0, mr: 1, ml: 3, mb: 2 }}
          onClick={handleAddBuildingFloor}
        >
          Add Lot/Unit
        </Button>
      </GuardedComponent>
      {newBuilding && (
        <SaveHookFormDialog
          title="CREATE LOT/UNIT"
          config={{
            saveConfig: projectsApiKeyStore.createLot(),
          }}
          data={newBuilding}
          onClose={handleDialogClose}
          onSaveCompleted={onUnitCreated}
          formatSubmitdata={formatSubmitData}
          size="xl"
          yupSchema={validationSchema}
        >
          <div className="popupNoBg">
            {/* <BuildingFloorUnitForm name="unitData" isEnabled={true} /> */}
            <BuildingFloorUnitFormWithDefaultValue name="unitData" syncWithDux={syncWithDux} isEnabled={true} />
          </div>
        </SaveHookFormDialog>
      )}
    </>
  );
};
